( function( $ ) {
	$( document ).ready( function() {
		var $html = $( 'html' ),
			$nav = $( '.nav-sections' ),
			NAV_OPEN_CLASS = 'nav-open';

		$( '[data-action="toggle-nav"]' ).on( 'click', function() {
			if ($html.hasClass( NAV_OPEN_CLASS )) {
				$html.removeClass( NAV_OPEN_CLASS );
			} else {
				$html.addClass( NAV_OPEN_CLASS );
			}
		} );

		$( '.page-wrapper' ).on( 'click', function( e ) {
			if( $( e.target ).is( $nav ) || $( e.target ).parents( $nav ).length ) {
				return; // Inside the nav, don't close it
			} else {
				$html.removeClass( NAV_OPEN_CLASS );
			}
		} );
	} );
} )( jQuery );